import axios from 'axios';
import { getStore, removeStore } from '@/utils/util'
import { Toast } from 'vant';
import i18n from "@/lang";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
	baseURL: "/api",
	timeout: 30000
});

// 是否显示重新登录
export let isRelogin = { show: false };

// request拦截器
service.interceptors.request.use(
	(config) => {
		let token = getStore("token");
		let tokenHead = getStore("tokenHead");
		let lang = window.sessionStorage.getItem('lang') || 'zh_TW';

		if (token) {
			config.headers['Authorization'] = tokenHead + token
		}
		config.headers['Lang'] = lang;
		return config;
	},
	(error) => {
		console.log(error);
		return Promise.reject();
	}
);

// 响应拦截器
service.interceptors.response.use(
	(response) => {
		const code = response.data.code || 200;
		// 获取错误信息
		const msg = response.data.message || i18n.t('common.system_error');

		if (code === 401) {
			if (!isRelogin.show) {
				Toast(i18n.t('common.token_expired'));
				isRelogin.show = false;
				setTimeout(() => {
					removeStore("token")
					handleUnauthorizedRedirect();
				}, 1000)
			}
			return Promise.reject(i18n.t('common.session_expried'))
		} else if (code == 500) {
			Toast(msg);
			return Promise.reject(new Error(msg))
		} else {
			return response.data
		}
	},
	(error) => {
		let { message } = error;

		if (message == "Network Error") {
			message = i18n.t('common.connect_error');
		}
		else if (message.includes("timeout")) {
			message = i18n.t('common.system_timeout');
		}
		else if (message.includes("Request failed with status code")) {
			message = i18n.t('common.system_api') + message.substr(message.length - 3) + i18n.t('common.exception');
		}
		Toast(message);
		return Promise.reject(error)
	}
);

/**
 * 处理401未授权错误的重定向逻辑
 */
function handleUnauthorizedRedirect() {
	const currentPath = window.location.pathname;
	const search = window.location.search;
	const urlParams = new URLSearchParams(search);
	const hasOrderId = urlParams.has('orderId');

	console.log('currentPath', currentPath);

	// 定义重定向规则
	const redirectRules = [
		{
			condition: () => currentPath === '/recordDetail' && hasOrderId,
			loginPath: '/login',
			withRedirect: true
		},
		{
			condition: () => currentPath === '/beauty/recordDetail' && hasOrderId,
			loginPath: '/beauty/login',
			withRedirect: true
		},
		{
			condition: () => currentPath.startsWith('/beauty/'),
			loginPath: '/beauty/login',
			withRedirect: false
		}
	];

	// 查找匹配的规则
	const matchedRule = redirectRules.find(rule => rule.condition());

	if (matchedRule) {
		const loginUrl = matchedRule.withRedirect
			? `${matchedRule.loginPath}?redirect=${encodeURIComponent(currentPath + search)}`
			: `${matchedRule.loginPath}${search}`;

		location.href = loginUrl;
	} else {
		// 默认重定向
		location.href = `/login/${search}`;
	}
}

export default service;
